// Add a new industry by appending one object here — no component/CSS changes needed.
const industries = [
  {
    id: "machine-shops",
    title: "Machine Shops",
    image: "/images/IndustriesImages/MachineShop.jpg",
    bg: "/images/IndustriesImages/MachineShopBG.png",
    intro:
      "Alpha 1 Industrial Services offers comprehensive turnkey solutions for industrial equipment and machine shop moving across the Lower Mainland, including Surrey, Richmond, Vancouver, and Burnaby.",
  },
  {
    id: "commercial",
    title: "Commercial",
    image: "/images/IndustriesImages/Commercial.jpeg",
    bg: "/images/IndustriesImages/CommercialBG.png",
    intro:
      "Alpha 1 Industrial Services offers specialized installation and relocation services for commercial equipment across the Lower Mainland, including Surrey, Richmond, Vancouver, and Burnaby. We cater to a variety of sectors such as restaurants, hospitals, schools and universities, food manufacturing facilities, bakeries, commercial laundries, and warehouse inventory moving — ensuring efficient and secure setup and moving of machinery and equipment critical to your operations.",
  },
  {
    id: "warehouse",
    title: "Warehouse",
    image: "/images/IndustriesImages/WareHouse.jpg",
    bg: "/images/IndustriesImages/WareHouseBG.png",
    intro:
      "Warehouses, pivotal in supply chains, house products before their final journeys. Adapting to evolving industries, Alpha 1 Industrial Services excels in orchestrating industrial equipment movement. From Surrey to Vancouver, we navigate the intricate landscape of machinery relocation — turning storage spaces into dynamic hubs that play a crucial role in commerce.",
    list: [
      "Container Loading and Unloading",
      "Trans Loading",
      "Machine Storage",
    ],
  },
  {
    id: "manufacturing-shops",
    title: "Manufacturing Shops",
    image: "/images/IndustriesImages/ManufacturingShops.jpeg",
    bg: "/images/IndustriesImages/ManufacturingShopsBG.png",
    intro:
      "In workshops, raw materials morph into intricate creations, bridging imagination and engineering. Alpha 1 Industrial Services exemplifies this realm, orchestrating industrial equipment relocation. These shops blend tradition and technology, crafting products of legacy and progress — where skilled artisans and machinery forge dedication, and Alpha 1 Industrial Services pioneers transformation.",
  },
];

export default industries;
